export const getInitials = (value?: string | null): string => {
  if (!value) {
    return "?";
  }

  const clean = value.trim();
  if (clean === "") {
    return "?";
  }

  const parts = clean.split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }

  const first = parts[0].charAt(0);
  const last = (parts.at(-1) ?? "").charAt(0);
  return `${first}${last}`.toUpperCase();
};
